import { render, staticRenderFns } from "./JoinUser.vue?vue&type=template&id=c1b9fe1e&scoped=true&"
import script from "./JoinUser.vue?vue&type=script&lang=js&"
export * from "./JoinUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b9fe1e",
  null
  
)

export default component.exports